import React, { useEffect, useState } from 'react'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import { useStore } from '../store/store';
import Star from '../assets/star.svg'
import Tick from '../assets/tick.svg'
import Spark from '../assets/spark.svg'
import Gluten from '../assets/gluten.svg'
import Dairy from '../assets/dairy.svg'
import NonGmo from '../assets/non_gmo.svg'
import SoyIcon from '../assets/soy.svg'
import PeaNutIcon from '../assets/peanut.svg'
import ShellFishIcon from '../assets/shellfish.svg'
import ProductSkeleton from '../components/ProductSkeleton';
import ShoppingBagIcon from '../assets/shopping_bag.svg'
import { appRoutes } from '../utils/app_routes';
import ProductReviewsTab from '../components/ProductReviewsTab';

const Product = () => {
    const { pathname } = useLocation()
    const route = pathname.replace(/[-/]/g, '_').replace(/^_/, '');
    const { state: { products } } = useStore();
    const [pName, setPName] = useState(route)

    const navigate = useNavigate();

    useEffect(() => {
        setPName(route)
    }, [route])

    const handleChange = (e) => {
        navigate(`/${e.target.value.replaceAll('_', '-')}`);
    };

    const productAddHandler = () => {
        // const cart = JSON.parse(localStorage.getItem('cart-items')) || [];
        // if (!cart.includes(route)) {
        //     cart.push(route);
        // }
        // localStorage.setItem('cart-items', JSON.stringify(cart));
        // console.log(cart);

        localStorage.setItem("cart-product", route)
        navigate(appRoutes.checkout)
    };


    if (products.length && products.find(i => i.productName === pName)) {
        const product = products.find(i => i.productName === pName)
        return (
            <div className='py-10 xl:py-[100px] px-[4%] sm:px-[6%] xl:px-[10%] 2xl:px-[12.6%] w-full'>
                <div className='flex flex-col md:flex-row gap-10 xl:gap-[100px] w-full'>
                    <div className='w-full md:w-[44.1%] max-h-[538px] aspect-square bg-[#F0F0F0] flex justify-center items-center rounded-[20px]'>
                        <img src={product.productImagePath} alt={product.productName} className='w-[40%]' />
                    </div>
                    <div className='w-full md:w-[55.9%] text-start'>
                        <div className='flex justify-between gap-4 flex-col min-[1620px]:flex-row'>
                            <div className='text-start'>
                                <p className='text-[clamp(1.5rem,4vw,2.5rem)] capitalize font-semibold leading-[clamp(2rem,5vw,3.125rem)]'>
                                    {product.productName.replaceAll('_', ' ')}
                                </p>
                                <p className='text-gradient bg-gradient-3 text-[16px] font-[500] leading-[26px] flex-wrap mt-[10px]'>Performance and Strength*</p>
                            </div>
                            <div className='flex flex-col gap-1 md:justify-end'>
                                <div className=' flex gap-2 items-center flex-wrap min-[1620px]:justify-end h-6'>
                                    <div className='flex gap-[3px]'>
                                        <img src={Star} alt="Star" className='w-[18px]' />
                                        <img src={Star} alt="Star" className='w-[18px]' />
                                        <img src={Star} alt="Star" className='w-[18px]' />
                                        <img src={Star} alt="Star" className='w-[18px]' />
                                        <img src={Star} alt="Star" className='w-[18px]' />
                                    </div>
                                    <p className='text-[16px] font-[500] leading-[normal]'>5/5</p>
                                    <p className='text-secondary'>|</p>
                                    <p className='text-[16px] font-[500] leading-[normal]'>499 reviews</p>
                                </div>
                                <p className='text-[12px] font-[400] leading-[24px]'>81% of customers recommend this product</p>
                            </div>
                        </div>
                        <div className='mt-5 mb-4 text-[clamp(0.8rem,4vw,1.25rem)] font-[400] leading-[26px]'>
                            Join 27,827+ subscribers in reaching their health goals
                        </div>
                        <div>
                            {products.map((p, inx) => (
                                <div key={inx} className='w-full border px-4 py-3 xl:py-5 xl:px-[30px] rounded-[8px] border-[#00000020] flex justify-between items-center'>
                                    <div>
                                        <div>
                                            <p className='text-[clamp(0.8rem,4vw,1.25rem)] font-semibold leading-[26px]'>{p.productQty} Bottles</p>
                                            <p className='text-[clamp(0.6rem,4vw,0.88rem)] font-normal leading-6'>every months</p>
                                        </div>
                                        <div>

                                        </div>
                                    </div>
                                    <div>
                                        <p className='text-[clamp(1.2rem,4vw,2.5rem)] font-semibold leading-[clamp(1.2rem,4vw,2.5rem)]'>${p.price}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                        {/* Or element */}
                        <div className='my-2 w-full flex items-center'>
                            <div className='w-full border-t border-[#00000040]'></div>
                            <p className='mx-[18px]'>or</p>
                            <div className='w-full border-t border-[#00000040]'></div>
                        </div>
                        {/* One time purchase */}
                        <div className='w-full border px-4 py-5 xl:py-5 xl:px-[30px] rounded-[8px] border-[#00000020] flex flex-col md:flex-row gap-5 flex-wrap justify-between items-center'>
                            <div className='flex items-center flex-col 2xl:flex-row justify-between gap-3 w-full 2xl:w-auto'>
                                <p className='text-[clamp(1.2rem,4vw,1.25rem)] font-semibold leading-[26px] 2xl:max-w-[120px]'>One Time Purchase</p>
                                <div className='flex flex-col items-center 2xl:items-start'>
                                    <div>
                                        <span className='text-[#14EDB9]  text-[14px] font-[700] leading-[normal] border border-[#14EDB9] text-center px-2 py-1'>
                                            Save 13%
                                        </span>
                                    </div>
                                    <p className='text-[#14EDB9] text-[12px] font-normal leading-[normal] mt-2'>Only $1.13 per day</p>
                                </div>
                            </div>
                            <div className='flex gap-[26px] items-center justify-between w-full 2xl:w-auto'>
                                <div className='text-center '>
                                    <p className='text-[12px] font-medium leading-[normal] text-secondary'>Select Quantity</p>
                                    <select
                                        name="product"
                                        id="Product"
                                        onChange={handleChange}
                                        defaultValue={product.productName}
                                        className='w-[100px] mt-1 h-[26px] text-[12px] font-semibold px-3 bg-transparent outline-none border border-secondary'
                                    >
                                        {products.map((i, indx) => <option key={indx} value={i.productName}>{i.productQty} Bottles</option>)}
                                    </select>
                                </div>
                                <p className='text-[clamp(1.9rem,4vw,2.5rem)] font-semibold leading-[clamp(1.2rem,4vw,2.5rem)]'>${product.price}</p>
                            </div>
                        </div>
                        <div className='mt-5 flex flex-col md:justify-between min-[1720px]:items-end gap-4 min-[1720px]:flex-row'>
                            <div>
                                <div className='flex flex-col md:flex-row md:items-center gap-x-[10px]'>
                                    <p className='text-[14px] font-semibold leading-[24px]'>You’ve Selected 6 Month Subscription</p>
                                    <p className='underline text-[11px] font-normal leading-[22px] text-secondary'>View All Subscription Benefits (7)</p>
                                </div>
                                <div className='flex flex-row  mt-[14px] gap-[10px]'>
                                    <div className='flex flex-row flex-wrap basis-1/2 gap-[10px]'>
                                        <div className='flex gap-1 items-center'>
                                            <img src={Tick} alt="" />
                                            <p className='text-[14px] font-normal leading-[24px] text-secondary'>Biggest Savings Locked In</p>
                                        </div>
                                        <div className='flex gap-1 items-center'>
                                            <img src={Tick} alt="" />
                                            <p className='text-[14px] font-normal leading-[24px] text-secondary'>Free U.S. Shipping on all Orders</p>
                                        </div>
                                    </div>
                                    <div className='flex flex-row flex-wrap basis-1/2 gap-[10px]'>
                                        <div className='flex gap-1 items-center'>
                                            <img src={Tick} alt="" />
                                            <p className='text-[14px] font-normal leading-[24px] text-secondary'>Out-of-Stock Protection</p>
                                        </div>
                                        <div className='flex gap-1 items-center'>
                                            <img src={Tick} alt="" />
                                            <p className='text-[14px] font-normal leading-[24px] text-secondary'>Pause or Cancel any Time</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <button onClick={productAddHandler} className="btn-primary min-w-[200px] flex gap-2 items-center justify-center">
                                <p>Add to Bag</p>
                                <img src={ShoppingBagIcon} alt="Bag" className="h-5 w-5" />
                            </button>
                        </div>
                        <div className='mt-4 md:mt-10 flex gap-y-[20px] flex-col flex-wrap md:flex-row'>
                            <div className='flex flex-row flex-wrap gap-y-[20px] gap-x-[10px] basis-1/2'>
                                <div className='flex gap-1 items-start'>
                                    <img src={Spark} alt="" />
                                    <p className='text-[clamp(0.8rem,4vw,1rem)] font-normal leading-[24px]'>Traditional Herbs with Modern Elements*</p>
                                </div>
                                <div className='flex gap-1 items-start'>
                                    <img src={Spark} alt="" />
                                    <p className='text-[clamp(0.8rem,4vw,1rem)] font-normal leading-[24px]'>Comprehensive Male Health Support*</p>
                                </div>
                            </div>
                            <div className='flex flex-row flex-wrap gap-y-[20px] gap-x-[10px] basis-1/2'>
                                <div className='flex gap-1 items-start'>
                                    <img src={Spark} alt="" />
                                    <p className='text-[clamp(0.8rem,4vw,1rem)] font-normal leading-[24px]'>For Maintaining Healthy Stamina & Muscle*</p>
                                </div>
                                <div className='flex gap-1 items-start'>
                                    <img src={Spark} alt="" />
                                    <p className='text-[clamp(0.8rem,4vw,1rem)] font-normal leading-[24px]'>With Shilajit & Ashwagandha*</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='my-7 md:mb-[100px] md:mt-[60px] grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-6 gap-3 md:gap-10 uppercase'>
                    <div className='flex justify-center items-center w-full py-2 md:py-[11px] gap-2 rounded-full border border-black'>
                        <img src={Gluten} alt="Gluten" className='h-[65%] md:h-auto' />
                        <p className='text-[14px] font-semibold leading-6'>Gluten-Free</p>
                    </div>
                    <div className='flex justify-center items-center w-full py-2 md:py-[11px] gap-2 rounded-full border border-black'>
                        <img src={Dairy} alt="Dairy" className='h-[65%] md:h-auto' />
                        <p className='text-[14px] font-semibold leading-6'>Dairy-Free</p>
                    </div>
                    <div className='flex justify-center items-center w-full py-2 md:py-[11px] gap-2 rounded-full border border-black'>
                        <img src={NonGmo} alt="NonGmo" className='h-[65%] md:h-auto' />
                        <p className='text-[14px] font-semibold leading-6'>Non-GMO</p>
                    </div>
                    <div className='flex justify-center items-center w-full py-2 md:py-[11px] gap-2 rounded-full border border-black'>
                        <img src={SoyIcon} alt="SoyIcon" className='h-[65%] md:h-auto' />
                        <p className='text-[14px] font-semibold leading-6'>Soy-Free</p>
                    </div>
                    <div className='flex justify-center items-center w-full py-2 md:py-[11px] gap-2 rounded-full border border-black'>
                        <img src={PeaNutIcon} alt="PeaNutIcon" className='h-[65%] md:h-auto' />
                        <p className='text-[14px] font-semibold leading-6'>Peanut-Free</p>
                    </div>
                    <div className='flex justify-center items-center w-full py-2 md:py-[11px] gap-2 rounded-full border border-black'>
                        <img src={ShellFishIcon} alt="ShellFishIcon" className='h-[65%] md:h-auto' />
                        <p className='text-[14px] font-semibold leading-6'>shellfish-Free</p>
                    </div>
                </div>
                <ProductReviewsTab />
            </div>
        )
    } else if (products.find(i => i.productName !== pName)) {
        return <Navigate to={appRoutes.home} />
    }
    return <div className='py-10 xl:py-[100px] px-[4%] sm:px-[6%] xl:px-[10%] 2xl:px-[12.6%]'>
        <ProductSkeleton />
    </div>

}

export default Product